import React, { useRef } from 'react';
import classnames from 'classnames';
import { useEnteredView } from '@fiverr-private/hooks';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { Text } from '@fiverr-private/typography';
import { Heading } from '../ui/Heading';
import { translate } from '../../../shared/helpers';
import { sendBiankaImpression } from '../../../shared/biEvents';
import { EVENT_NAMES } from '../../../shared/biEvents/eventNames';
import { sendMixpanelEvent } from '../utils/mixpanel';
import { MIXPANEL_EVENTS } from '../utils/eventNames';
import { FAQ_ITEMS } from './constants';

import * as styles from './styles.ve.css';

const FAQs = () => {
  const container = useRef<HTMLDivElement>(null);
  const eventTrackingRef = useRef<HTMLDivElement>(null);

  useEnteredView(eventTrackingRef, {
    threshold: 1,
    onEntered: () => {
      sendBiankaImpression({
        eventName: EVENT_NAMES.BIANKA.EXPERTS_CAROUSEL_IS_SHOWN,
        componentName: 'faqs',
        componentText: 'FAQs',
      });
    },
  });

  const handleFAQClick = (item: (typeof FAQ_ITEMS)[0], index: number) => {
    sendMixpanelEvent({
      eventName: MIXPANEL_EVENTS.CLICKED_FAQ_ITEM,
      clickedElement: translate(item.question),
      position: index + 1,
    });
  };

  return (
    <Container ref={container}>
      <Stack direction="column" className={styles.wrapperStyles} gap="0">
        <Heading textAlign={{ default: 'start', sm: 'center' }} ref={eventTrackingRef}>
          {translate('v17.faqs.heading')}
        </Heading>

        <Stack direction={{ default: 'column', md: 'row' }} className={styles.itemsContainer}>
          {FAQ_ITEMS.map((item, index) => (
            <Stack
              as="a"
              href={item.url}
              key={item.key}
              direction="column"
              flex="1"
              gap="0"
              className={styles.itemContainer}
              onClick={() => handleFAQClick(item, index)}
            >
              <Container
                className={classnames(styles.imageContainer, { [styles.imageContainerPositionTop]: item.positionTop })}
              >
                <Image
                  src={{
                    default: item.imageMobile,
                    sm: {
                      srcSet: {
                        regular: item.image,
                        retina: item.image,
                      },
                    },
                  }}
                  alt={translate(item.question)}
                  height="100%"
                  width="100%"
                  objectFit="cover"
                />
              </Container>

              <Text color="white" className={styles.questionText}>
                {translate(item.question)}
              </Text>

              <Text color="white" className={styles.answerText}>
                {translate(item.answer)}
              </Text>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Container>
  );
};

export default FAQs;
